export default "__VITE_ASSET__ef4bd1c8__"